'use strict';

require('./shim')();



//////////////////
// WEBPACK FOOTER
// ./node_modules/array.prototype.flat/auto.js
// module id = 1528
// module chunks = 8